module.exports = __webpack_public_path__ + "static/media/Coursio_next_white.d812c50e.png";